import {useState} from 'react'
import {ModalBase} from '../../../../components/Modals/ModalBase'
import {PREFIJOS_CODIGO_ESTABLECIMIENTO_V2} from '../../../../utils/normativa.utils'
import {
  EJEMPLO_SERIE_V2,
  LONGITUD_SERIE,
  describirSerie,
  diagnosticarSerieV2,
  normalizarSerie,
  validarSerieDocumentoTecleo,
} from '../../../../utils/series.utils'
import {SerieDocumento} from '../useSeriesDocumentos'

interface PropiedadesModalEditarSerie {
  documento: SerieDocumento
  guardando: boolean
  onCancelar: () => void
  onGuardar: (serie: string) => Promise<string>
}

const ModalEditarSerie = ({
  documento,
  guardando,
  onCancelar,
  onGuardar,
}: PropiedadesModalEditarSerie) => {
  const [serie, setSerie] = useState(documento.serie)
  const [errorFormato, setErrorFormato] = useState('')
  const [errorServicio, setErrorServicio] = useState('')

  const diagnostico = diagnosticarSerieV2(serie)
  const descripcion = describirSerie(serie)

  const manejarCambio = (evento: any) => {
    const valor = evento.target.value
    if (valor.length > LONGITUD_SERIE) return
    if (!validarSerieDocumentoTecleo(valor)) return
    setSerie(normalizarSerie(valor))
    setErrorFormato('')
    setErrorServicio('')
  }

  const manejarGuardar = async (evento: any) => {
    evento.preventDefault()
    if (guardando) return

    if (diagnostico) {
      setErrorFormato(diagnostico)
      return
    }

    if (normalizarSerie(serie) === normalizarSerie(documento.serie)) {
      setErrorFormato('La serie no cambió. Modifíquela o presione Cancelar.')
      return
    }

    const mensaje = await onGuardar(serie)
    if (mensaje) {
      setErrorServicio(mensaje)
      return
    }
    onCancelar()
  }

  return (
    <ModalBase Styles={{minWidth: '30%', maxWidth: '640px', padding: '2%'}}>
      <form className='form-content' onSubmit={manejarGuardar}>
        <div>
          <h3 className='card-title l'>Corregir serie del documento</h3>
        </div>
        <div className='separador'></div>
        <p className='field-label m' style={{marginBottom: '4px'}}>
          {documento.nombreSucursal} · {documento.nombreDocumento}
        </p>
        <p className='s' style={{marginTop: 0, color: '#6b7280'}}>
          Serie registrada actualmente: <strong>{documento.serie || 'sin serie'}</strong>
        </p>
        <div className='w-layout-hflex h-inputs'>
          <div className='label-input'>
            <label htmlFor='serie' className='field-label m'>
              Serie
              <span style={{color: 'red'}}>*</span>
            </label>
            <input
              autoComplete='off'
              type='text'
              className='m text-field w-input'
              name='serie'
              id='serie'
              placeholder={EJEMPLO_SERIE_V2}
              value={serie}
              onChange={manejarCambio}
              maxLength={LONGITUD_SERIE}
            />
            {errorFormato && <p className='alert s'>{errorFormato}</p>}
            {!errorFormato && descripcion && (
              <p className='s' style={{color: '#15803d', marginTop: '4px'}}>
                Formato correcto: {descripcion}
              </p>
            )}
          </div>
        </div>
        <div style={{background: '#f3f4f6', borderRadius: '8px', padding: '12px 16px'}}>
          <p className='field-label m' style={{marginTop: 0, marginBottom: '8px'}}>
            Cómo se arma la serie
          </p>
          <p className='s' style={{marginTop: 0, marginBottom: '8px'}}>
            Una letra de establecimiento, su número de tres dígitos, la letra P y el número de punto
            de venta de tres dígitos. Ejemplo: <strong>{EJEMPLO_SERIE_V2}</strong>.
          </p>
          <ul className='s' style={{marginTop: 0, marginBottom: 0, paddingLeft: '18px'}}>
            {PREFIJOS_CODIGO_ESTABLECIMIENTO_V2.map((tipo) => (
              <li key={tipo.letra}>
                <strong>{tipo.letra}</strong> · {tipo.descripcion}
              </li>
            ))}
          </ul>
        </div>
        {documento.correlativosEmitidos > 0 && (
          <p className='s' style={{color: '#b45309'}}>
            Este documento ya tiene correlativos emitidos. Al corregir la serie, el correlativo
            continúa donde va; no se reinicia.
          </p>
        )}
        {errorServicio && <p className='alert s'>{errorServicio}</p>}
        <div className='separador'></div>
        <div className='w-layout-hflex button-actions'>
          <button
            type='button'
            className='m button transparent w-inline-block'
            onClick={onCancelar}
            disabled={guardando}
          >
            <div>Cancelar</div>
          </button>
          <button type='submit' className='m button w-inline-block' disabled={guardando}>
            <div>{guardando ? 'Guardando...' : 'Guardar serie'}</div>
          </button>
        </div>
      </form>
    </ModalBase>
  )
}

export default ModalEditarSerie
